

import {numericFormatter } from 'react-number-format'

const globalPercentFormatter = new Intl.NumberFormat("en-US", {
        style: "percent",
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });

export const currencyFormat = (value) => {
    value += '';
    return numericFormatter(value, { thousandSeparator: true, prefix: '$', decimalScale: 2, fixedDecimalScale: true })
}

export const percentFormat = (value) => {
    if (value == null) {
        return '';
    }
    value += '';
    return numericFormatter(value, { thousandSeparator: true, suffix: '%', decimalScale: 1, fixedDecimalScale: true });
}

export const decimalAsPercentFormat = (value) => {
    return globalPercentFormatter.format(value);
}